import { Component } from '@angular/core';
import { ThemeService } from '../../services/ThemeService';

@Component({
  selector: 'app-header1',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  isDarkMode = localStorage.getItem('darkMode') === 'enabled';

  constructor(private themeService: ThemeService) {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      
      const chatbot = document.querySelector('chatbot-widget') as any;
      if (chatbot) {
        chatbot.mode = this.isDarkMode;
      }
    });
  }

  toggleTheme() {
    this.themeService.setDarkMode(!this.isDarkMode);
  }

}